<template>
  <div class="member-center">
    <div class="content-container">
      <!-- 左側按鈕區 -->
      <div class="sidebar">
        <button
          @click="showSection('memberInfo')"
          :class="{ active: currentSection === 'memberInfo' }"
        >
          會員資料
        </button>
        <button
          @click="showSection('orderDetails')"
          :class="{ active: currentSection === 'orderDetails' }"
        >
          訂單詳情
        </button>
      </div>

      <!-- 右側內容顯示區 -->
      <div class="main-content">
        <!-- 會員資料區 -->
        <div v-if="currentSection === 'memberInfo'">
          <div class="member-header">
            <h1>會員資料</h1>
           <button class="logout-button header-logout" @click="handleLogout">登出</button>
            <button
              @click="changePassword"
              class="save-btn change-password-btn"
            >
              修改密碼
            </button>
          </div>
          <div class="info-item">
            <label>會員Email：</label>
            <span>{{ member.email }}</span>
          </div>

          <div class="info-item">
            <label for="old-password">舊密碼：</label>
            <input
              type="password"
              id="old-password"
              v-model="oldPassword"
              placeholder="輸入舊密碼"
            />
          </div>

          <div class="info-item">
            <label for="new-password">新密碼：</label>
            <input
              type="password"
              id="new-password"
              v-model="newPassword"
              placeholder="輸入新密碼"
            />
          </div>

          <div class="info-item">
            <label>會員姓名：</label>
            <span>{{ member.fullName }}</span>
          </div>

          <div class="info-item">
            <label>會員電話：</label>
            <span>{{ member.phone }}</span>
          </div>

          <div class="info-item">
            <label>會員生日：</label>
            <span>{{ formatDate(member.birth) }}</span>
          </div>
        </div>

        <!-- 訂單詳情區 -->
        <div
          class="fixed-order-tabs-container"
          v-if="currentSection === 'orderDetails'"
        >
          <h2 class="order-title">訂單詳情</h2>

          <div class="order-tabs">
            <button
              @click="filterOrders('全部')"
              :class="{ active: currentOrderFilter === '全部' }"
            >
              全部
            </button>
            <button
              @click="filterOrders('已付款')"
              :class="{ active: currentOrderFilter === '已付款' }"
            >
              已付款
            </button>
            <button
              @click="filterOrders('未付款')"
              :class="{ active: currentOrderFilter === '未付款' }"
            >
              未付款
            </button>
            <button
              @click="filterOrders('已完成')"
              :class="{ active: currentOrderFilter === '已完成' }"
            >
              已完成
            </button>
            <button
              @click="filterOrders('已取消')"
              :class="{ active: currentOrderFilter === '已取消' }"
            >
              已取消
            </button>
          </div>

          <div class="order-content">
            <div
              v-for="order in filteredOrders"
              :key="order.orderId"
              class="order-item"
            >
              <h3>訂單編號：{{ order.Id }}</h3>
              <p>總金額：NT$ {{ order.TotalAmount.toLocaleString() }}</p>
              <p>付款狀態：{{ order.PaymentStatus }}</p>
              <p>訂單狀態：{{ order.OrderStatus }}</p>
              <p>訂單日期：{{ formatDate(order.CreatedDate) }}</p>

              <h4>訂單明細：</h4>
              <ul>
                <li v-for="detail in order.Details" :key="detail.Id">
                  房型名稱：{{ detail.RoomTypeName }}<br />
                  入住日期：{{ formatDate(detail.CheckInDate) }}<br />
                  退房日期：{{ formatDate(detail.CheckOutDate) }}<br />
                  單價：NT$ {{ detail.UnitPrice.toLocaleString() }}<br />
                  住宿天數：{{ detail.StayNights }} 晚<br />
                  房間號碼：{{ detail.RoomNumber }}<br />
                  套餐名稱：{{ detail.PackageName || "無" }}
                </li>
              </ul>
            </div>
            <p v-if="filteredOrders.length === 0">目前沒有對應的訂單。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userLogic from "@/assets/js/user.js"; // 引用用戶相關邏輯
import customerLogic from "@/assets/js/customer.js"; // 引用訂單相關邏輯

export default {
  name: "CustomerDashboard",
  mixins: [userLogic, customerLogic], // 混入用戶邏輯和訂單邏輯
  data() {
    return {
      currentSection: "memberInfo", // 當前顯示的區域
    };
  },
  methods: {
    showSection(section) {
      this.currentSection = section;
    },
  },
  mounted() {
    // 如果需要初始化兩個模組的功能，可以在此調用
    this.fetchMemberInfoAndOrders(); // customer.js 方法
    this.initializeUserLogic(); // user.js 方法（假設 user.js 有此方法）
  },
};
</script>

<style src="@/assets/css/user.css" scoped></style>
